/**
 * 快捷命令组件（欢迎页）
 */

import React from 'react';
import { useChatStore } from '@/stores';

interface QuickCommandsProps {
  onCommand?: (command: string) => void;
  storageReady?: boolean;
}

const QUICK_COMMANDS = [
  { command: '查看服务器状态', icon: '📊', title: '服务器状态', desc: 'CPU、内存、磁盘' },
  { command: '检查网络连接', icon: '🌐', title: '网络检查', desc: '连通性和端口' },
  { command: '查看系统日志', icon: '📋', title: '系统日志', desc: '最近日志和错误' },
  { command: '安全检查', icon: '🔒', title: '安全检查', desc: '防火墙和登录' },
];

export const QuickCommands: React.FC<QuickCommandsProps> = ({
  onCommand,
  storageReady = true,
}) => {
  const isProcessing = useChatStore((s) => s.isProcessing);
  const disabled = !onCommand || !storageReady || isProcessing;

  const handleClick = (command: string) => {
    if (disabled) return;
    onCommand?.(command);
  };

  return (
    <div className="sse-ai-welcome">
      <div className="welcome-icon">🚀</div>
      <h3>AI 运维助手</h3>
      <p>管理服务器、执行命令、排查问题</p>
      <div className="quick-commands">
        {QUICK_COMMANDS.map((cmd) => (
          <button
            key={cmd.command}
            type="button"
            className="quick-command-btn"
            disabled={disabled}
            onClick={() => handleClick(cmd.command)}
          >
            <div className="title">{cmd.icon} {cmd.title}</div>
            <div className="desc">{cmd.desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
};